import React, {useContext, useState} from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faMinusCircle} from "@fortawesome/free-solid-svg-icons"
import LinesEllipsis from 'react-lines-ellipsis'

import {TeacherContext} from 'teacher/context'
import {isEmpty} from 'helpers/utils'

import PreviewQuestionTooltip from './preview-question-tooltip'

const useStyles = makeStyles(cartPopperStyles)

export default function CartQuestion (props) {
  const context = useContext(TeacherContext)
  const classes = useStyles()
  const {translate, quizQuestionBankCart: cart, updateState} = context
  const {index, textpremise, typeName} = props
  const premiseLabel = isEmpty(textpremise) ? translate(typeName) : textpremise

  const [open, setOpen] = React.useState(false)

  const removeQuestion = () => {
    const updateCommand = cart.length == 1
      ?  {quizQuestionBankCart: {$splice: [[index, 1]]}, quizQuestionBankCartEl: {$set: null}}
      :  {quizQuestionBankCart: {$splice: [[index, 1]]}}
    updateState(updateCommand)
  }

  const handleTooltipClose = () => {
    setOpen(false)
  }

  const handleTooltipOpen = () => {
    setOpen(true)
  }

  return (
      <Box className={classes.question}>
        <Box className={classes.questionHeader}>
            <Box className={classes.removeQuestion} onClick={removeQuestion}>
                <Box className={classes.removeQuestionButton}>
                  <FontAwesomeIcon icon={faMinusCircle} />
                </Box>
            </Box>
            <Box className={classes.questionPremise} >
              <LinesEllipsis
                text={premiseLabel}
                maxLine={2}
                ellipsis="..."
                trimRight
                basedOn='letters'
              />
            </Box>
            <Box className={classes.questionFooter}>
                <PreviewQuestionTooltip {...props} />
            </Box>
          </Box>
      </Box>)
}

function cartPopperStyles(theme) {
  return  {
    question: {
      marginTop: 4,
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#fff',
      borderRadius: '3px',
      border: '1px solid #bfcdd8',
      color: '#4f5670',
      padding: 0,
      "&:first-child": {
        marginTop: 3
      },
      "&:last-child": {
        marginBottom: 3
      },
      "&:hover": {
        backgroundColor: '#f4f4f4'
      }
    },
    questionHeader: {
      display: 'inline-flex',
      position: 'relative',
      justifyContent: 'end'
    },
    questionFooter: {
      fontSize: 16,
      margin: 'auto 6px',
      width: '7%'

    },
    questionPremise: {
      padding: 9,
      width: '88%',
      maxHeight: '35px',
    },
    removeQuestion: {
      margin: 'auto 6px',
      width: '4%',
      textAlign: 'center'

    },
    removeQuestionButton: {
      cursor: 'pointer',
      color: '#d33d60'
    },
  }
}

